import React, { useState, useEffect, Suspense, useRef } from 'react'

import classes from "./DeviceManager.module.css";

import FilterSearch from "../PowerSearch/PowerSearch";
import DeviceLoadingGrid from '../GridList/DeviceLoadingGrid';
import DevicesGrid from '../GridList/DevicesGrid';
import { Await, useNavigate } from 'react-router-dom';
import CategoryFilter from '../PowerSearch/CategoryFilter';
import SortDevices from '../PowerSearch/SortDevices';
import GetAllDevices from '../../Pages/AllSites/GetAllDevices';
import ExportExcel from '../ExcelExport/ExcelExport';
import UseDateFormat from '../hooks/UseDateFormat';
import PowerSearch from '../PowerSearch/PowerSearch';
import GetPagedDevices from '../../Pages/AllSites/GetPagedDevices';
import GetAllPagedDevices from '../../Pages/AllSites/GetAllPagedDevices';
import { useDispatch, useSelector } from 'react-redux';
import DataManager from '../../hooks/DataManager';
import Button1 from '../UI/Button/Button1';
import { he } from 'date-fns/locale';
import gridIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/grid.png'
import listIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/list.png'
import { addSitesToGroup, inviteUser } from '../../Api Methods/Api';
import UsersTableLayout from '../Table/UsersTableLayout';
import DevicesList from '../GridList/DevicesList';
import { Tooltip, Whisper } from 'rsuite';
import Modal from '../../components/Modal/Modal';
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import fail from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import InviteUserForm from '../forms/InviteUserForm';
import SelectRoleForm from '../forms/SelectRoleForm';
import loading from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import Button2 from '../UI/Button/Button2';
import { Button } from 'primereact/button';
import settings24 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings24.png'

const DeviceManager = ({ client, token, companyName, aiQuery, getAllDevices }) => {
    const dataManager = new DataManager();
    let [filteredResults, setFilteredResults] = useState([]);
    let [maxPagedFetches, setMaxPagedFetches] = useState(2);
    getAllDevices = 1;
    dataManager.setItem('getAllDevices', getAllDevices);
    const groups = useSelector(state => state.auth.groups);
    const parsedGroups = JSON.parse(groups);
    const companyNameNew = useSelector(state => state.auth.companyName);
    const hasCachedSites = dataManager.getItem('filteredResults')?.length > 0
    const [isloading, setIsLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState(dataManager.getItem('searchQuery'));
    const [categoryFilter, setCategoryFilter] = useState([]);
    const [sortBy, setSortBy] = useState('all')
    const [isGetAllDevicesPressed, setIsGetAllDevicesPressed] = useState(dataManager.getItem('allSitesPressed'));
    const [pageFetchedIndex, setPageFetchedIndex] = useState(dataManager.getItem('pageIndex'));
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'));
    const [totalDevices, setTotalDevices] = useState(0);
    const [totalPages, setTotalPages] = useState(null);
    const navigate = useNavigate();
    const addAccessMode = dataManager.getItem('isAddAccessMode')
    const [title, setTitle] = useState('');
    const [modalComponent, setModalComponent] = useState();
    const [userRole, setUserRole] = useState();
    const userID = useSelector(state => state.auth.userID);
    const [showResetButton, setShowResetButton] = useState(false)
    const [reset, setReset] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)
    const apiData = {
        token,
        client
    }
    const [update, setUpdate] = useState(0)
    const [viewType, setViewType] = useState(dataManager.getItem('viewType'))
    const [groupMode, setGroupMode] = useState(dataManager.getItem('isGroupMode'));
    const dispatch = useDispatch();
    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    const handleFilterLogic = async (data, searchQuery, selectedCategories, sortBy) => {
        function hasDevicesKey(data) {
            return Array.isArray(data) && data.every(entry => entry.hasOwnProperty('devices'));
        }

        let flattenedDataDevices;

        if (hasDevicesKey(data)) {
            flattenedDataDevices = data.flatMap(entry => entry.devices);
        } else {
            flattenedDataDevices = data
        }

        let sortedData = flattenedDataDevices;
        let preFilteredData;
        sortedData != undefined ? preFilteredData = sortedData : preFilteredData = data;

        let flattenedData;

        if (hasDevicesKey(preFilteredData)) {
            flattenedData = preFilteredData.flatMap(entry => entry.devices);
        } else {
            flattenedData = preFilteredData
        }

        setFilteredResults(flattenedData);
    };

    useEffect(() => {
        setFilteredResults(dataManager.getItem('filteredResults'));
        setPageFetchedIndex(dataManager.getItem('pageIndex'));
        setTotalDevices(dataManager.getItem('totalDevices'));
        setTotalPages(dataManager.getItem('totalPages'));
    }, [aiQuery])

    const HandleSaveSearchQuery = () => {
        localStorage.setItem('SavedSearchFilters', JSON.stringify(categoryFilter));
        localStorage.setItem("SavedSearchSortOrder", JSON.stringify(sortBy));
        dataManager.setItem('filteredResults', filteredResults);
        dataManager.setItem('totalPages', totalPages);
        dataManager.setItem('totalDevices', totalDevices);
    }

    useEffect(() => {
        const SaveSearchFilters = JSON.parse(localStorage.getItem('SavedSearchFilters'));
        const SavedSortBy = JSON.parse(localStorage.getItem("SavedSearchSortOrder"))
        SaveSearchFilters != null && setCategoryFilter(SaveSearchFilters);
        SavedSortBy != null && setSortBy(SavedSortBy);

        if (getAllDevices == 1) {
            if (!hasCachedSites) {
                setIsGetAllDevicesPressed(true);
                dataManager.setItem('allSitesPressed', true);
            }
        }
    }, [getAllDevices])

    useEffect(() => {
        dataManager.setItem('filteredResults', filteredResults)
        dataManager.setItem('deviceUUIDs', filteredResults.map(device => device.uuid)); //UUIDs to observe for pinStates
    }, [filteredResults])

    const showError = (response) => {
        setTitle("Error")
        setModalComponent(
            <div>
                <div>
                    <h3 style={{ textAlign: "center" }}>Error</h3>
                </div>
                <div>
                    <p style={{ textAlign: "center" }}>{response.msg}</p>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px" // Adds space between buttons
                }}>
                    <Button1 onClick={HandleCloseModal}>Close</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const navigateToGroup = () => {
        HandleCloseModal();
        navigate('/Dashboard/Groups/GroupSites')
    }

    const successModal = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={check}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Action completed successfully</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 onClick={navigateToGroup} style={{ width: "100%" }}>Take me there</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const successModalAddUsers = (message) => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={check}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 onClick={cancelAddAccess} style={{ width: "100%" }}>Close</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const showLoadingModal = () => {
        setTitle('Please wait...')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={loading}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{"Adding user to selected sites..."}</h3>
                </div>
                <br></br>
                <br></br>
            </div>
        )
        HandleShowModal();
    }

    const exportData = filteredResults?.map((site) => {

        return {
            "Tag": site.tag,
            "UIPIOID": site.key,
            "Serial Number": site.subGroup,
            "IP Address": site.ip,
            "Firmware": site.firmware,
            "Status": site.status,
            "Initial Activation": UseDateFormat(site.created),
            "Owned by": site.name,
        }
    })

    useEffect(() => {
        console.log(pageFetchedIndex)
    }, [pageFetchedIndex])

    useEffect(() => {
        if (dataManager.getItem('allSitesPressed')) {
            <GetAllPagedDevices
                searchQuery={searchQuery}
                setIsLoading={setIsLoading}
                handleFilterLogic={handleFilterLogic}
                categoryFilter={categoryFilter}
                sortBy={sortBy}
                setSearchQuery={setSearchQuery}
                setIsGetAllDevicesPressed={setIsGetAllDevicesPressed}
                isGetAllDevicesPressed={isGetAllDevicesPressed}
                filteredResults={filteredResults}
                setFilteredResults={setFilteredResults}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageNumber={pageFetchedIndex}
                setPageNumber={setPageFetchedIndex}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                setTotalDevices={setTotalDevices}
                totalDevices={totalDevices}
                getAllDevices={getAllDevices}
            />;
        }
    }, [pageFetchedIndex])

    const AddSitesToGroup = async () => {
        let body = {
            groupID: dataManager.getItem('groupClickedID'),
            groupName: dataManager.getItem('groupClicked'),
            groupDevices: dataManager.getItem('selectedSites'),
        }

        const response = await addSitesToGroup(apiData, body, dispatch);

        if (response) {
            successModal();
            dataManager.setItem('isGroupMode', false);
            dataManager.setSelectedSites([]);
            setGroupMode(false);
        } else {
            //error
            showError(response.msg)
        }
    }

    const chooseRole = () => {
        setTitle("Choose role")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3>Choose a role for this user</h3>
                <p>Please note, this role will apply to ALL selected sites</p>
                <small>You can change this role later using the 'Change Role' feature available in the user sites dropdown menu</small>
                <br></br>
                <SelectRoleForm
                    setUserRole={setUserRole}
                    HandleCloseModal={HandleCloseModal}
                    HandleShowLoadingModal={showLoadingModal}
                    HandleAddUserSites={addSiteAccessForUser} />
                <Button1 onClick={HandleCloseModal}>Cancel</Button1>
            </div>
        )
        HandleShowModal();
    }

    const addSiteAccessForUser = async () => {
        const sitesToAdd = dataManager.getItem('selectedSites')
        console.log(sitesToAdd)
        if (sitesToAdd.length > 0) {
            let allSuccessful = true;
            let criticalError = false;
            let alreadyExists = false;
            let sitesUserWasAlreadyOn = []

            for (const site of sitesToAdd) {
                const { deviceID, deviceName } = site;
                const userToAddID = dataManager.getItem('clickedUserID');
                const role = dataManager.getItem('roleSelectedForUserInvite');
                const emailAddress = dataManager.getItem('clickedUserEmailAddress');

                const response = await inviteUser(apiData, deviceID, userID, role, emailAddress, deviceName, companyNameNew, dispatch);
                if (!response.success) {
                    allSuccessful = false;
                    if (response.msg === "Relationship already exists") {
                        sitesUserWasAlreadyOn.push(deviceID)
                        alreadyExists = true
                    } else {
                        errorModal("Something went wrong, please try again.");
                        criticalError = true
                        break;
                    }
                }
            }

            // If all were successful, show success and reset data
            if (allSuccessful) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length} site(s)`);
                dataManager.setSelectedSites([]);
            } else if (!criticalError && alreadyExists) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length - sitesUserWasAlreadyOn.length} site(s). \nUser already had access to ${sitesUserWasAlreadyOn.length} of the selected sites`);
                dataManager.setSelectedSites([]);
            } else if (criticalError) {
                errorModal("Something went wrong, please try again");
                dataManager.setSelectedSites([]);
                dataManager.setItem('addAccessMode', false)
            }
        } else {
            errorModal("Please select a site");
        }
    }

    const errorModal = (message) => {
        setTitle('Error')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={fail}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 style={{ width: "100%" }} onClick={HandleCloseModal}>Close</Button1>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const cancel = () => {
        setGroupMode(false);
        dataManager.setItem('isGroupMode', false);
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Groups/GroupSites')
    }

    const cancelAddAccess = () => {
        dataManager.setItem('isAddAccessMode', false)
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Users/UserSites')
    }

    const HandleResetFilters = () => {
        setShowResetButton(false)
        setReset(reset + 1)
    }

    useEffect(() => {

        console.log(searchQuery)
        console.log(isGetAllDevicesPressed)
        console.log(filteredResults)
        console.log(viewType)

    }, [searchQuery, isGetAllDevicesPressed, filteredResults, viewType])

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <div className={classes.DeviceManagerPage}>
                <div className={classes.searchContainer}>
                    {/* Search Bar */}
                    <PowerSearch
                        placeholder={"Search sites..."}
                        searchQuery={searchQuery}
                        categoryFilter={categoryFilter}
                        setCategoryFilter={setCategoryFilter}
                        setSearchQuery={setSearchQuery}
                        setIsLoading={setIsLoading}
                        setFilteredResults={setFilteredResults}
                        handleFilterLogic={handleFilterLogic}
                        categories={["Online", "Offline", "NoTag", "Favorited", "Not Favorited"]}
                        isGetAllDevicesPressed={isGetAllDevicesPressed}
                        setIsGetAllDevicesPressed={setIsGetAllDevicesPressed}
                        filteredResults={filteredResults}
                        setSortBy={setSortBy}
                        sortBy={sortBy}
                        hasCachedSites={hasCachedSites}
                        pageSize={pageSize}
                        pageFetchedIndex={pageFetchedIndex}
                        setTotalPages={setTotalPages}
                        setTotalDevices={setTotalDevices}
                        reset={reset}
                    />

                    {(categoryFilter.length > 0 || (sortBy !== 'all' && sortBy.length > 0) || showResetButton == true) &&
                        <Button type="button" style={{ marginRight: "15px" }} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger' />
                    }

                    <GetAllPagedDevices
                        searchQuery={searchQuery}
                        setIsLoading={setIsLoading}
                        handleFilterLogic={handleFilterLogic}
                        categoryFilter={categoryFilter}
                        sortBy={sortBy}
                        setSearchQuery={setSearchQuery}
                        setIsGetAllDevicesPressed={setIsGetAllDevicesPressed}
                        isGetAllDevicesPressed={isGetAllDevicesPressed}
                        filteredResults={filteredResults}
                        setTotalPages={setTotalPages}
                        setFilteredResults={setFilteredResults}
                        setMaxPagedFetches={setMaxPagedFetches}
                        maxPagedFetches={maxPagedFetches}
                        pageFetchedIndex={pageFetchedIndex}
                        setPageFetchedIndex={setPageFetchedIndex}
                        setTotalDevices={setTotalDevices}
                        totalDevices={totalDevices}
                        getAllDevices={getAllDevices}
                    />
                </div>

                <div className={classes.buttonContainer}>
                    {groupMode && <Button severity='secondary' outlined style={{ width: "250px", height: "50px", fontSize: "15px", marginTop: "10px" }} onClick={AddSitesToGroup}>Add selected sites to {dataManager.getItem('groupClicked')}</Button>}
                    {groupMode && <Button outlined severity="danger" style={{ width: "100px", height: "50px", fontSize: "15px", marginTop: "10px" }} onClick={cancel} label='Cancel' />}
                    {addAccessMode && <Button severity='secondary' outlined style={{ width: "250px", height: "50px", fontSize: "15px", marginTop: "10px" }} onClick={chooseRole} label='Add selected sites' />}
                    {addAccessMode && <Button severity='danger' outlined style={{ width: "100px", height: "50px", fontSize: "15px", marginTop: "10px" }} onClick={cancelAddAccess} label='Cancel' />}

                </div>

                <div style={{ display: "flex", width: "100%", height: "10%", alignItems: "center" }}>
                    {/* {showMassSettings && (
                    <div style={{marginTop:"10px", marginRight:"10px", marginBottom:"10px"}}>
                   <Button      label="Settings" icon="pi pi-cog" onClick={HandleMassAction}/>
                    </div>
                )} */}
                    <p>Total results: {totalDevices}</p>
                </div>

                <Suspense fallback={
                    <div style={{ display: "flex", width: "100%" }}>
                        <DeviceLoadingGrid />
                    </div>
                }>
                    <Await resolve={filteredResults}>
                        {(loadedFilteredResults) => (
                            <div style={{ display: "flex", width: "100%", height: "100%" }}>
                                {isloading ? (
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <DeviceLoadingGrid
                                            CardCount={
                                                searchQuery?.length === 2
                                                    ? 10
                                                    : searchQuery?.length >= 3 && 1
                                            }
                                        />
                                    </div>
                                ) : searchQuery !== "" ||
                                    searchQuery !== " " ||
                                    isGetAllDevicesPressed ? (
                                    loadedFilteredResults && loadedFilteredResults?.length !== 0 ? (
                                        viewType === 0 ? (
                                            // Render DevicesGrid when viewType is 0
                                            <DevicesGrid
                                                data={loadedFilteredResults}
                                                HandleSaveSearchQuery={HandleSaveSearchQuery}
                                                totalPages={totalPages}
                                                setTotalPages={setTotalPages}
                                                pageFetchedIndex={pageFetchedIndex}
                                                setPageFetchedIndex={setPageFetchedIndex}
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalDevices={totalDevices}
                                                setTotalDevices={setTotalDevices}
                                                groupMode={groupMode}
                                                apiData={apiData}
                                            />
                                        ) : (
                                            // Render DevicesList when viewType is 1
                                            <DevicesList
                                                devices={loadedFilteredResults}
                                                filtering={""}
                                                hideControls={false}
                                                HandleSaveSearchQuery={HandleSaveSearchQuery}
                                                totalPages={totalPages}
                                                setTotalPages={setTotalPages}
                                                pageFetchedIndex={pageFetchedIndex}
                                                setPageFetchedIndex={setPageFetchedIndex}
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalDevices={totalDevices}
                                                setTotalDevices={setTotalDevices}
                                                groupMode={groupMode}
                                                update={update}
                                                setUpdate={setUpdate}
                                                isSortable={false}
                                                showMassSelect={true}
                                                showMassSettings={showMassSettings}
                                                setShowMassSettings={setShowMassSettings}
                                            />
                                        )
                                    ) : (
                                        "No sites found"
                                    )
                                ) : (
                                    ""
                                )}
                            </div>
                        )}
                    </Await>
                </Suspense>
            </div>
        </>
    )
}

export default DeviceManager